const setupRolePermissionToggles = () => {
    if (document.body.dataset.rolePermissionTogglesReady === "true") {
        return;
    }

    document.body.dataset.rolePermissionTogglesReady = "true";

    const getPermissionForm = (event) => event.detail?.elt?.closest?.(".rcd-permission-switch-form");

    const setSavingState = (form, isSaving) => {
        const checkbox = form?.querySelector("[data-permission-switch]");
        form?.classList.toggle("is-saving", isSaving);
        if (checkbox) {
            checkbox.disabled = isSaving;
        }
    };

    const updateRolePermissionCounts = (roleId) => {
        if (!roleId) {
            return;
        }

        const roleWorkspace = document.querySelector(`[data-role-permission-count="${roleId}"]`)?.closest(".rcd-role-access");
        const count = roleWorkspace
            ? roleWorkspace.querySelectorAll("[data-permission-switch]:checked").length
            : null;

        if (count === null) {
            return;
        }

        document.querySelectorAll(`[data-role-permission-count="${roleId}"], [data-role-list-permission-count="${roleId}"]`)
            .forEach((element) => {
                element.textContent = String(count);
            });
    };

    document.body.addEventListener("htmx:beforeRequest", (event) => {
        const form = getPermissionForm(event);
        if (!form) {
            return;
        }

        const checkbox = form.querySelector("[data-permission-switch]");
        if (checkbox) {
            checkbox.dataset.previousChecked = checkbox.checked ? "true" : "false";
        }

        setSavingState(form, true);
    });

    document.body.addEventListener("htmx:configRequest", (event) => {
        const form = getPermissionForm(event);
        if (!form) {
            return;
        }

        const checkbox = form.querySelector("[data-permission-switch]");
        const valueInput = form.querySelector("[data-permission-value]");
        const nextValue = checkbox?.checked ? "true" : "false";

        if (valueInput) {
            valueInput.value = nextValue;
        }

        event.detail.parameters["PermissionInput.IsAssigned"] = nextValue;
    });

    document.body.addEventListener("htmx:afterRequest", (event) => {
        const form = getPermissionForm(event);
        if (!form) {
            return;
        }

        const checkbox = form.querySelector("[data-permission-switch]");
        setSavingState(form, false);

        if (event.detail.successful) {
            updateRolePermissionCounts(form.dataset.roleId);
            return;
        }

        if (checkbox) {
            checkbox.checked = checkbox.dataset.previousChecked === "true";
        }

        window.rcdAdmin?.toast?.({
            type: "danger",
            title: "Permission not saved",
            message: event.detail.xhr?.responseText || "Refresh the page and try again."
        });
    });
};

const setupRoleOrderControls = () => {
    document.querySelectorAll("[data-role-order-list]").forEach((list) => {
        if (list.dataset.roleOrderReady === "true") {
            return;
        }

        list.dataset.roleOrderReady = "true";

        const listKey = list.dataset.roleOrderList;
        const select = document.getElementById(`${listKey}-role-select`);

        const getRows = () => Array.from(list.querySelectorAll("[data-role-order-item]"));
        const getCurrentOrder = () => getRows().map((row) => row.dataset.roleOrderItem).filter(Boolean);
        const updateMoveControls = () => {
            const rows = getRows();
            rows.forEach((row, index) => {
                row.querySelectorAll("[data-role-order-form]").forEach((form) => {
                    const control = form.querySelector("button");
                    const isFirst = index === 0;
                    const isLast = index === rows.length - 1;
                    const shouldDisable = form.dataset.roleOrderMove === "up" ? isFirst : isLast;
                    control.disabled = shouldDisable;
                    control.classList.toggle("is-disabled", shouldDisable);
                    control.setAttribute("aria-hidden", shouldDisable ? "true" : "false");
                });
            });
        };

        const syncSelectOrder = (order) => {
            if (!select) {
                return;
            }

            const options = Array.from(select.options);
            const optionByValue = new Map(options.map((option) => [option.value, option]));
            const orderedOptions = order
                .map((roleId) => optionByValue.get(roleId))
                .filter(Boolean);
            const remainingOptions = options.filter((option) => !order.includes(option.value));

            [...orderedOptions, ...remainingOptions].forEach((option) => select.appendChild(option));
        };

        const syncOrder = () => {
            const order = getCurrentOrder();
            syncSelectOrder(order);
            updateMoveControls();
        };

        document.body.addEventListener("htmx:beforeRequest", (event) => {
            const form = event.detail?.elt?.closest?.("[data-role-order-form]");
            if (!form || !list.contains(form)) {
                return;
            }

            form.classList.add("is-saving");
            form.querySelector("button")?.setAttribute("disabled", "disabled");
        });

        document.body.addEventListener("htmx:afterRequest", (event) => {
            const form = event.detail?.elt?.closest?.("[data-role-order-form]");
            if (!form || !list.contains(form)) {
                return;
            }

            form.classList.remove("is-saving");
            const row = form.closest("[data-role-order-item]");
            const direction = form.dataset.roleOrderMove;
            const order = getCurrentOrder();
            const currentIndex = order.indexOf(row?.dataset.roleOrderItem);
            const targetIndex = direction === "up" ? currentIndex - 1 : currentIndex + 1;

            if (!event.detail.successful) {
                window.rcdAdmin?.toast?.({
                    type: "danger",
                    title: "Role order not saved",
                    message: event.detail.xhr?.responseText || "Refresh the page and try again."
                });
                syncOrder();
                return;
            }

            if (currentIndex < 0 || targetIndex < 0 || targetIndex >= order.length || !row) {
                syncOrder();
                return;
            }

            const rows = getRows();
            const targetRow = rows[targetIndex];
            if (direction === "up") {
                list.insertBefore(row, targetRow);
            } else {
                list.insertBefore(targetRow, row);
            }

            syncOrder();
        });

        syncOrder();
    });
};

export { setupRolePermissionToggles, setupRoleOrderControls };
